export const Links = [
  { veza: "Naslovna", link: "/", color: "#32bde3" },
  { veza: "O nama", link: "/Onama", color: "#32bde3" },
  { veza: "Usluge", link: "/#usluge", color: "#aea8b2" },
  { veza: "Cjenik", link: "/Cjenik", color: "#32bde3" },
  { veza: "Naši radovi", link: "/NasiRadovi", color: "#32bde3" },
  { veza: "Savjeti stručnjaka", link: "/#savjeti", color: "#aea8b2" },
  { veza: "Kontakt", link: "/#kontakt", color: "#aea8b2" },
  { veza: "Podnošenje prigovora", link: "/prigovor.docx", color: "#aea8b2" },
]
